<div class="pd-util" *ngIf="u">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h6 class="mb-0">Utilisation du module</h6>
      <p class="mb-0 text-muted small">Cases à cocher par domaine fonctionnel (niveau module).</p>
    </div>
    <button type="button" class="btn btn-primary btn-sm" (click)="save()">Enregistrer</button>
  </div>

  <div class="row">
    <div class="col-md-6 mb-3" *ngFor="let bloc of [
      {
        title: 'Promotions',
        items: [
          { k: 'promoDeclenchement', l: 'Utilisable comme critère de déclenchement' },
          { k: 'promoExclusion', l: 'Utilisable comme critère d\'exclusion' },
          { k: 'promoRegroupement', l: 'Utilisable comme regroupement' }
        ]
      },
      {
        title: 'Tarification',
        items: [
          { k: 'tarifRegles', l: 'Utilisable dans règles tarifaires' },
          { k: 'tarifGenerationPrix', l: 'Utilisable dans génération automatique des prix' }
        ]
      },
      {
        title: 'Reporting',
        items: [
          { k: 'reportingBi', l: 'Utilisable dans filtres BI' },
          { k: 'reportingExports', l: 'Utilisable dans exports analytiques' }
        ]
      },
      {
        title: 'Workflow',
        items: [
          { k: 'workflowValidations', l: 'Utilisable dans validations' },
          { k: 'workflowAutomatisations', l: 'Utilisable dans automatisations' }
        ]
      },
      {
        title: 'Recherche',
        items: [
          { k: 'rechercheSimple', l: 'Utilisable dans recherche simple' },
          { k: 'rechercheAvancee', l: 'Utilisable dans recherche avancée' }
        ]
      }
    ]">
      <div class="card pd-util__card h-100">
        <div class="card-header py-2"><strong>{{ bloc.title }}</strong></div>
        <div class="card-body">
          <div class="custom-control custom-checkbox mb-2" *ngFor="let it of bloc.items">
            <input
              type="checkbox"
              class="custom-control-input"
              [id]="moduleKey + '-' + it.k"
              [(ngModel)]="$any(u)[it.k]"
              [name]="moduleKey + it.k"
            />
            <label class="custom-control-label" [for]="moduleKey + '-' + it.k">{{ it.l }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
